"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animateDropdownTransformOutConfig = exports.animateDropdownTransformInConfig = exports.animateDropdownOpacityOutConfig = exports.animateDropdownOpacityInConfig = void 0;
const baseDropdownAnimations = {
  easing: 'global',
  duration: 'moderate3'
};
const fromTransformValue = -16;
const toTransformValue = 0;
const animateDropdownOpacityInConfig = Object.assign({
  property: 'opacity',
  fromValue: 0,
  toValue: 1
}, baseDropdownAnimations);
exports.animateDropdownOpacityInConfig = animateDropdownOpacityInConfig;
const animateDropdownOpacityOutConfig = Object.assign({
  property: 'opacity',
  fromValue: 1,
  toValue: 0
}, baseDropdownAnimations);

// property based on placement
exports.animateDropdownOpacityOutConfig = animateDropdownOpacityOutConfig;
const animateDropdownTransformInConfig = Object.assign({
  fromValue: fromTransformValue,
  toValue: toTransformValue
}, baseDropdownAnimations);
exports.animateDropdownTransformInConfig = animateDropdownTransformInConfig;
const animateDropdownTransformOutConfig = Object.assign({
  fromValue: toTransformValue,
  toValue: fromTransformValue
}, baseDropdownAnimations);
exports.animateDropdownTransformOutConfig = animateDropdownTransformOutConfig;